import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'shock-angle',
  standalone: true,
  
  templateUrl: './shock-angle.component.html',
  styleUrl: './shock-angle.component.scss'
})
export class ShockAngleComponent implements OnInit {

  ngOnInit() {

  }

}
